import { ChangeEvent, useEffect, useState } from 'react'
import { Stack } from '@chakra-ui/react'

import { MaskedInput } from 'components/dataEntry'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import { pisMask } from 'utils/masks'
import { removeEverythingThatIsNotNumber } from 'utils/transforms/string'
import { CustomFormViewerQuestionProps } from 'components/tools/CustomForm/types/CustomFormViewerQuestionProps'
import { useCustomFormViewer } from 'components/tools/CustomForm/components/Viewer/contexts/CustomFormViewerManager/Provider'
import validatePISOnCustomForm from 'components/tools/CustomForm/components/Viewer/utils/validatePISOnCustomForm'
import useCustomFormGetDefaultValue from '../../../../hooks/useCustomFormGetDefaultValue'

export default function CustomFormPISQuestion({
  question,
  questionKey,
  disabled,
  formMethods,
}: CustomFormViewerQuestionProps) {
  const [pisNumber, setPISNumber] = useState<string>('')

  const { removeErrorFromQuestion, setErrorOnQuestion, thisQuestionHasError } = useCustomFormViewer()

  const questionWithError = thisQuestionHasError(question.slug)?.question

  async function handleOnChange(event: ChangeEvent<HTMLInputElement>) {
    const pis = event.target.value
    setPISNumber(pis)
    const errorMessage = validatePISOnCustomForm({ pis, isRequired: question.is_required })
    if (errorMessage === '' && formMethods?.watch) {
      formMethods.setValue(questionKey, removeEverythingThatIsNotNumber(pis))
      removeErrorFromQuestion(question.slug)
    } else {
      setErrorOnQuestion(question, errorMessage)
    }
  }

  const { defaultValue } = useCustomFormGetDefaultValue({ question, questionKey, disabled })

  useEffect(() => {
    const defaultPIS = defaultValue
    if (defaultValue) {
      setPISNumber(defaultPIS)
    }
    if (formMethods?.setValue) {
      formMethods.setValue(questionKey, defaultValue)
    }
  }, [defaultValue])

  return (
    <Stack>
      <MaskedInput
        id={question.slug}
        value={pisNumber}
        onChange={handleOnChange}
        mask={pisMask}
        isDisabled={disabled}
        placeholder={question?.placeholder}
      />

      <CustomFormFieldErrorMessage message={questionWithError?.error_message} />
    </Stack>
  )
}
